module.exports = __webpack_public_path__ + "ec63688462ab96b02f6007b64418b648.pdf";